import { getLocalStorageItem, setLocalStorageItem } from './sessionUtils';
import { ACCESS_TOKEN_KEY } from '../constants/sessionStorage';

export const getAuthToken = () => getLocalStorageItem(ACCESS_TOKEN_KEY);

export const isAuthenticated = (): boolean => {
  const token = getAuthToken();
  if (!token) {
    return false;
  }

  return true;

  // const expiresAt = storageService.getItem(STORAGE_KEY_EXPIRES_AT);
  // return new Date().getTime() < parseInt(expiresAt, 10);
};

export const getAuth0AccessToken = (): string => {
  if (isAuthenticated()) {
    return `Bearer ${getAuthToken()}`;
  }
  return '';
};

export const setAuth0LoginResponseToLocalStorage = (authResult): void => {
  setLocalStorageItem(ACCESS_TOKEN_KEY, authResult.token);

  // const expiresAt = JSON.stringify(authResult.expires_in * 1000 + new Date().getTime());
  // storageService.setItem(STORAGE_KEY_ACCESS_TOKEN, authResult.access_token);
  // storageService.setItem(STORAGE_KEY_ID_TOKEN, authResult.id_token);
  // storageService.setItem(STORAGE_KEY_EXPIRES_AT, expiresAt);
};

export const clearAuthKeysInLocalStorage = (): void => {
  // storageService.removeItem(STORAGE_KEY_ACCESS_TOKEN);
  // storageService.removeItem(STORAGE_KEY_ID_TOKEN);
  // storageService.removeItem(STORAGE_KEY_EXPIRES_AT);
  // storageService.clearAll();
};
